'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.applyOverrides = exports.adaptForI18n = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _enviro = require('enviro');

var _enviro2 = _interopRequireDefault(_enviro);

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

var _setIn = require('transmute/setIn');

var _setIn2 = _interopRequireDefault(_setIn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var enableDebug = _enviro2.default.debug('copy_machine');
var debugLog = function debugLog(path, value) {
  if (enableDebug) {
    var I18nKey = path.join('.');
    console.log('Copy Machine debug log\nReplacing copy for "' + I18nKey + '"\nVariant copy: "' + value + '"');
  }
};

var adaptForI18n = exports.adaptForI18n = function adaptForI18n() {
  var overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return overrides.map(function (_ref) {
    var copyKey = _ref.copyKey,
        copyOverride = _ref.copyOverride;
    return {
      path: copyKey.split('.'),
      value: copyOverride
    };
  });
};

var applyOverrides = exports.applyOverrides = function applyOverrides() {
  var translations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var overrides = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  var copy = _extends({}, translations);
  overrides.forEach(function (_ref2) {
    var path = _ref2.path,
        value = _ref2.value;

    var translation = (0, _getIn2.default)(path, copy);
    if (typeof translation === 'string') {
      copy = (0, _setIn2.default)(path, value, copy);
      debugLog(path, value);
    }
  });
  return copy;
};


//////////////////
// WEBPACK FOOTER
// ./js/utils/copyMachineUtils.js
// module id = 341
// module chunks = 3 4 5